<template>
    <div class="box">
        <div class="title">
            <i class="iconfont icon-renshu"></i>
            选择接收人角色
        </div>
        <div class="body">
            <div @click="checkbox(index)" :style="[checkbox_list==index?check_on:'']" v-for="(item,index) in tag_list" :key="index" class="checkbutton">
                <div class="checktext">{{item}}</div>
                <div :style="[checkbox_list==index?on:'']" class="checkbox"></div>
            </div>
        </div>
        <div class="input_box">
            <div class="input_text">
                <i class="iconfont icon-bianji"></i>
                请输入接收姓名
            </div>
            <div class="input_content">
                <input v-model="receive_name" maxlength="8" placeholder="请输入接收人的姓名" type="text" class="input">
            </div>
        </div>
        <div class="chooseStroe" v-if="this.$route.query.from == 'ChildInformation'">
            <DropdownMenu>
                <DropdownItem :title="chooseTitle" :disabled="option1.length==0 ?true :false" v-model="stroeValue" :options="option1" @change="chooseStroe" @open="dropDownOpen" @close="dropDownOpen"/>
            </DropdownMenu>
            <div class="chooseIcon" v-if="option1.length > 0">
                <img :src="OSSBaseUrl+'chooseStroe.png'" alt="" :class="dropDownUp ?'dropDownUp' :''">
            </div>
        </div>
        <div class="button_box">
            <div @click="popup_switch_show" class="btn bgc_blue">生成接收人二维码</div>
        </div>
        <div v-show="popup_show">
            <Popup>
                <template>
                    <div class="popup_content">
                        <div @click="popup_switch_close" class="close_img"><i class="iconfont icon-close"></i></div>
                        <div class="popup_title">
                            请微信扫码绑定
                        </div>
                        <div ref="imageTofile" class="qrcode_img_box">
                            <img class="qrcode_img" :src="qrcode" alt="二维码">
                            <img class="qrcode_icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFHGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDIwLTEyLTE1VDEwOjA4OjUwKzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMC0xMi0xNVQxMDowOTozMCswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMC0xMi0xNVQxMDowOTozMCswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDphNjljOTMxZS1jOGEzLWQxNDQtODE3OS00M2NjMzhjMGJkN2IiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6YTY5YzkzMWUtYzhhMy1kMTQ0LTgxNzktNDNjYzM4YzBiZDdiIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6YTY5YzkzMWUtYzhhMy1kMTQ0LTgxNzktNDNjYzM4YzBiZDdiIj4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDphNjljOTMxZS1jOGEzLWQxNDQtODE3OS00M2NjMzhjMGJkN2IiIHN0RXZ0OndoZW49IjIwMjAtMTItMTVUMTA6MDg6NTArMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChXaW5kb3dzKSIvPiA8L3JkZjpTZXE+IDwveG1wTU06SGlzdG9yeT4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7TCEfcAAARDElEQVRogcWaeZxU1ZXHv/e9V6/2rt4XoNm6QQIoBHEBXIJRonwwYjSSTNQQiSaaoEk+SUwyWUwmmRkZ4+ejSZAkalwySiKuERE1RswIEvZFQJqt6YXu6u6iupauqlfvvTt/3Gq6Ebob0Mmcz+d9qqvuu8vvnnN+59xzW6TwtQBhTlsEkky/b15AnP4wH60kRQqfPJOeEhfhCxIcX4fcvpUUNgIQeAADOKNhP7RoQPL0u7lILMw/PETjtg2I/bsI/34JoY9PBvK4ZIA8/w8aS2pn1k8t1JOOsgWYfngcjy76DvGNOwi++jThyy9B4hRMMs8/U1sihS/BGfiQJEuwKIKItlC9Kkj7dqidCLfOgcVFUPzKcvjad8kcasLunQwQ+D5SAB+Q5BkCUoQggfCKZfzuuq/wlfvADICVhpoR8MP5cIfIws518N52+OvfcZ/+C2nbKgDz83+gudMFJIAcLi6hmmGIHy2Gaz7Lkp46vr8SaopAE3AkBbYNM8+B+rEweRhcYsIFLQdg+ePYP32ATLIbDQPwfJTATgdQH02Hbr0JHvoNf9bD3L8Kdu2FcFEfBWgCHAlH0iDzgAMEYfY0+NYFMC/dBgu/SnLFix+1tk4VkMAlgwYEn1xG9MavcONaeH0dYEB1GDwauAOsSQiwHIgm1PfrZsMTUyHwq3tJ3fm9wgwfCahTASSQ5ACX0EvL2Xb1Ai7/I3S2QHXF4EA+KJqAnAPRKNRNgDeuhdHLHiB1+zcAoxDDPhSoU6FtB4lL6N6fsf/qBVz4CHRGYVQ16GJgMLZ7YpvjKlAjh8H+Bjj/KYh/9S5Cd92Oiw24HwYMMCRtCxwyhGecj1i7nnEvw749MKpCLfjEt0HToCkJUqr1lQchaIJlK7JAU7+PikBjO8ycAe9cDM64etL79qN/ONMbSkMWHkA89hA/TsC+rVA7AJheaU/BZ+qUOS29TK0tmYN4Fn50AbwxH+6cCh1pGFYBa/8GvwX0Pz6EDqhAfOYyiIYUEYSvmE3ba28y6lHw5iFiDrx/6bzSzN6bodKvfrvzbfjV32DmJHjn+r53P/407IiBLqFqBOydD76zxpPc24B25sF3MA25auG338hywGqHYu/gxpB3ocwPJV6lxbvXwppmIADVQfVOLAuL34a4BUUmVIag6X14BuDLCz40zw0CyMIPMOVC1rwP+Ap+MYiIQvzxaJDMw5LVsL0VCCmwADtj8Ou/QFsPlPoKxCHhxcPAJ+fgASD70QOSSDwVVdg149h/EDxDaKevn5ISL/z3F+Ci0UA3mMpBmFUDjy2CoAH7W6A1ASIA+TZgwsX4KUJH5YryDIAZg7bWVtNheoglwa8PPVjQUAtcsQ+ur4d/GQ+P7waPAe+2QnsGqvwwqRRqvPCtS+H8YRD2W2hGlFZDULr1TXx7Y7B+Lzz2G1Jdu4FTD7wDkoIkS+i8aTSt28QFK6CnG0KewQfTBKRyCsCVI2F/Aja0QVUY4j3KJC+qhuvHwqSqDjLmE2w8+lf2JRtoSXUSzQsiY6cysnwK0/0XcU3bBKof2479/ZvJYKMNDWrgTEGSJTRyFJmGQ0xdDYdboMw75AZhaJCw4GgadA8MDymgTQkwgVc/DeGSZfxk17d5uz1NyIAiA0xdmUDGcUjZ0COhdtRYvjn5Ub60azpy1tkk4weHilMDs5wAnKZm/J2NjBoB2dzQYECxW8CA4RGoDigi6UyDX4Pol4HI15j22u28eSRNuRdKPIIqXzkRo5iU7WC74BEwPhBEHjnA11/+BN+b+Ahi6wH8ZiUOGQY7CQ/Cch4y0oE9m7jgY0BG7fTpiiMhlYYX5kKzWMKlq5dyWeVoVl20koenvUS1bzQduRRtuW7mVM3lyfNWc+/ZS7GlIGCEODsQ5L7n7+I3o1bieeLVgtPbA843CCBDZVZPP88CH+CHjHP6gDp6YE49zBrVxMJ370Y34P5zHufi8rl8ouJqFtffQ2NPFo/QWDp1JTPL5rBgxO3MqZzP4Z4Uhubl7LCX/1g3jz0LqglMmoc7SDYxCCCJhsB6+Ckmp6LcME8lpcZpViHyGfhCPayJPch7cZhWHODf9/yYNzteAKDcrCHigbDHx22br2VL/H8AqDBrcKUKH2FPiFQ7LOc5uOmLg5ZeBl2ewEsGF+78Jg/UgbcSWhKgnyIoV4LuhTElsCX+LiUmFHnC/LlhDb898HMAbGnh0wAp+f22F/hT8zK1ETJ/zMQd6VLmg93Jd5AX1uJHMFDOpynGGBizgUH6D09RvWYVf1oEdhZimVMD5bjgNyHshaNWElPAkWycb55zIz+b+DAAfj1AwgYXh3tn3c3iun8DwKd7sfuRmVeHVDKKU2aio6OOwScDZHoYzMnAgwtkZs/jms79PPIdSKXgcPfQ5qdrkLFUbCo2Q+RciFk5pkTO4azwVABWti1HAF1WhmuHfY7h/jEA/L3zDYo9fRNYDgRDlegxCwcHOHmkN0RdEHd3CjHAC8qX/ORlBm3Cedzyjzeo/PY0Fj0FjU0QLi4krfLE6KAJcHJwMA5Tqy8gnn+HKZFiluz9LpvjawF4PfoC9aEIPY7NFzZczCXlc2nLNrEzsYkaXwmOBF1odGZgQtEMxPoWMsjC6fZ4EbiI7HW1ifyzTeGhUwt12DPR8D33KJ3XfpF/PQjL10CiE/BA0KtMo9ccHRdiCagvg1XXNfLFLaNJWSYhI8DhnjgAI/xFGJoHDUjZKdpzOXw61PhKjyXDPXaaaCDHazObmHjO10nuePH4I4YApIU2MpLU9OnlhcrLUMdfiY4fG5fkZxZSPv8qfpt9l20L4Zd3wqcug8rh4Hih21GP64O6iTDs41AeHsUPLvkdO7st8m6e0cEyRgZK0ISOK11s6eLTA4wKlFDlLcGVEiEEjsyzLZHjOzOfZ+KzcXp2vFgof/XDIwFcjMtKEe7mKxK5uRvDTttRhO5HOkMlgIphXGw8gG/e5XD9PJgyg1jtJNrKgqQKbxa5MKyrm6LDO2D1W/Cp2/jFuSv5xcu3UGtApb+0YKonzikQONJhT6KbRdf8J/c1301+/HAymda+9EeAEALcLAKB75UrkkI2zky4z7jh7LfXgzBA6MefewbEJ0CROgLwAcbwGphQD+WlqmNbB+zehxXtIAuEg7WINVt54tydPPDerRw8tJewBhEPGMJURxZhYupebNem20lxx8Rfsrj9FvjUDBIduxQYpRKEKKjHyeH90nD0B65KCnfjrISo8Ibtb8XIP7sVaXrBFcdY8Tg8A4KTQO5Yc++nOPYpAC8uWbyAec/jxBZfwvOlW1mTXkVzbAfpdAc6gu5oA6kUVPvDNDtJXr08ytkzfkz83WWYWgBkwTU0tf/kshgz6/Esq4aKc5PC3X9DQsTfDxOuxbmrGXvVVlzdROqaSsTcfjFKqIEonDKHOsGeuAH9qq+Vk2DBIriwntgYP93FAl3XaRlfyu867mPdxidJ9MBt1/2ce5aeTfZr1+AKL+ggdA3huAg7h37+WRgPVkFxCIZdkRROw3UJLRENIzNQUYd7bwx36eu4gOsNIqWLlK4qmYl+4NzC0+8nOagWP4g1i0SZqocw+CtBOHDl9fCTr/PKOe/z5N4f0mk0sMJ4i8jHriTT04YwA2hWj9rbm2ahf7cU0gdhxGehxJMU9qHbEnpsS5jgaGjeBtNnwfpS3PtXIf+2CzcHrvCA34NEIt0+FxayYAFOnyX0alJo/bR4QoAqtAOu7SKwervhAgEMtMVLsL5xJe+MbWVK1xgi5efhEEM3QVw1Ge2Oi+HcOGx4C0Z/HupGwdHDSWEn70noe94JE0hA+Sdg0wqYOg7KL4cNCeRr25BrNiB3tiJjauFuvzUW6okniOjXfjI5WfsHQ7uPEMy9BXKbsbt3oc+fjfjkBJjmh+hbsG4LTP0qjB0OnXvAiCRFvuOOhK5XhcXGx+CscTDsGvjHi+DshClXQ9G50NUCWw7Ank7k4SSyO4u08si8Dfk8MpcDWypNSVFQiwCkWrhOn9/1QnF6aVcqUzZ1NL8JpgfhMcA0wc2CL42YXouYfxkUFUPnOti6GtzxcO5CKDEgugXMCki3JEW+6eaECJeH9VwENj0I48+CutuhdSfsexay7VBeBzW1Kg2wLLBzkM+p+m7eVpdBSBBu76oVQKmr2rAmQCu0SwmuC44AqRXaAUOAaYDHA5oOmhc0Dxg6ZG3oikJPAoLjYPgcqKwH6wB0vQdGBIwQ7H0kKaymhQnhZMNaWR2aVQY77ocKByYuA0ZD198h2waaD4SuHjR18eNYIB1VPNA8anG9JxLHUomcdPvahVD9XQluTrWjqXahK8cSugJtW+DkwXVA2OAVECyF4EhwbYhvhFwS9AB4K6B5FRxZmxRW400JIQhjp9BLxyG8k9Wu+8vASaidlVlwejNyQwUAX7BgR1k4dpVfMCc3rzToNQvf06AVF7RnqVCg93pQDiiiLyZ4gAzkMqA5IG1wLbAzkIuD1VEAGVD9vRVwdCccehYMf9JAOgX7diGXhZAP3G7oekkdfjALscgtUJlU8yZsyNiqgritCyK6WmRrBmYPhxGlsLwB2ZJGfGkq8r/WIkYE4XPjlMk1JBSW2iCsaIBhAQU+3gMzh0N9KSSt3nSAQgAqbJyuQHorIHUIml4CzQDdi4F0kHYGzVeF8NVC22q1GyIIwt/nE70JoU8Hj4a8/hXY2w4TqmBkBFY2qEPLjFrEpWPAW4xcsgu2tiN3Z+GZ/chSH6zvRFxVB7NqkNNXIB6chVzTCa8eVHPVhBBvTQDdLGxiP06UvemLBG8JZDvg0HPKIsxikC6GcPJIoaGZJZDcr0xFeJWPSHHiYVagruEcCfVVYEnE8huQ1z4FR3oQb30eSMHyTbC9E/HwbOTrhxE3jEZaNhy14GMRsB3EwnHQnESMDSLLwyqwTS2D9+NQU0hzPphHSQlmCeSOwqEVkE+Ct/hYINSkk0UYRQg7A9bRgsMXIqV0lL32Pr3fDakce38H+HXkrc/BmkbYdQR552roySJvfFv5XbUXmrPIDVHY1gFRCyZF4JkG5KpGeL8b+adDUBWAmhCsOwKrGiHsKazDAfqtwSyGbBQOPQNW93FgADSkjZBC+YsUfYOc7Okd1MmramCxT5n2p0eoEmlpADG3Gqws4geTobYY2tMQ0qEzC9159fe+GNw9GSaWwdGsou99CWjtUZxQ5AHyfZvo2EpFZgQS+6DxecgnTgCjHEO6CCmVHdKbywxWOClcrHbkICXhcBqurodf74a2DFw5AqIpuGM8vNwCexOwOYZYNBZiOeQfGiGbh640bIgiLYm4eQwM9yM3dsGebhgTULTd6zNGQBFC5wboWK/o3TwRTAGQ0wdC9k9qBhC7cAF0Xgk0xsDwIyc+DUcy4Erk2KcQS2fCpCKI5go+J5EH0oq1bAlVJvKebeATKuhu7oBYBFpzkLLgH13w6WrFoI5PuULXJkg2guFXhHESMAAiv/PShOatDGtuHpzs8Rn1yeTYBZCpJkzmYUtMXQhpArqyMDYEpgabu6EuCF0WHEgqM60NwVkhaOyBurDKAv7aBm2WYtCIgKIAXDwM8llINkOyAew0eML0nV9OKkmR3z4zoXmrwpqVBDsOYog7k17prWHpAkIfuGaKW4oFR/ghnlcXR8cK4xJasxA2lOlqQm2GIVTKI3VI9cDhNsi1Qf4o6D6VCg19NkkaQrhhev9HwOoCI3wqHY+v8/Wc7AUJjYXqQvdJmrsLfip0SKTU/K6lNJHvBiet2rxFfeMNLWFDWrLVzXeGpV6CZnvBShQi8j9JZF4Rkmup7Nq11fxaIXM4vQuC5P8C9hd7Vn7OhKQAAAAASUVORK5CYII=" >
                        </div>
                        <!-- 下面这个图片是透明遮罩,用于长按识别 -->
                        <img class="qrcode_img_make" :src="synthesis_qrcode" alt="二维码">
                        <div class="popup_button_box">
                            <div class="popup_button">长按将二维码发送给接收人</div>
                        </div>
                    </div>
                </template>
            </Popup>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Popup from '@/components/Popup';
import html2canvas from 'html2canvas';
import ossUpload from '@/utils/oss_upload';
import { Toast , DropdownMenu , DropdownItem } from 'vant';

export default {
    name:'AddRecipientInfo',
    data(){
        return{
            OSSBaseUrl: this.$OSSBaseUrl,
            qrcode:null,
            synthesis_qrcode:null,
            timer:[], // 定时器列表
            popup_show:false,
            receive_name: '',
            check_on:{
                backgroundColor: 'rgb(33, 98, 247)',
                color: '#fff',
                border: 'none',
            },
            on:{
                backgroundImage:`url(${this.$OSSBaseUrl}checkbox_duihao.png)`,
                border: 'none',
            },
            checkbox_list: '1',
            tag_list:{a:'运营',b:'客服',c:'仓库',d:'其他',},
            chooseTitle: '请选择所属店铺',
            stroeValue: '',
            option1: [],
            dropDownUp: false,
            // boxShow: false
        }
    },
    components:{
        Popup, DropdownMenu, DropdownItem
    },
    beforeDestroy(){
        this.clear_timer_worker()
    },
    mounted() {
        this.now_router_params = this.$route.query.from
        if(this.$route.query.from == 'ChildInformation') {
            this.$store.dispatch('AddRecipientInfo/CheckShuntAccount',{}).then(res=>{
                let obj = {}
                if(res.data.length == 0) {
                    this.chooseTitle = "暂无可添加子账号的店铺"
                }else {
                    this.stroeValue = res.data[0].visitor_id
                    this.chooseTitle = res.data[0].visitor_nick
                    for(let i in res.data) {
                        obj = {text:res.data[i].visitor_nick, value:res.data[i].visitor_id}
                        this.option1.push(obj)
                    }
                }
            })
        }
    },
    methods:{
        checkbox(index){
            if(this.checkbox_list != index){
                this.checkbox_list = index
            }
        },
        toImage(){
            html2canvas(this.$refs.imageTofile,{
                backgroundColor: '#fff',  // 背景颜色
                dpi: 192,               // 将分辨率提高到特定的dpi,默认值为96
                scale: 2,               // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
                allowTaint:false,
                useCORS:true,           // 是否尝试使用CORS从服务器加载图像
                logging:true,           // 开启错误日志
            }).then((canvas)=>{
                let url = canvas.toDataURL('image/png')
                // this.synthesis_qrcode = url

                // 上传图片到OSS
                let that = this
                var uploader = new ossUpload({
                    dir: 'QRcodeImages',
                    maxSize: 100 * 1024 * 1024,
                    fileType: ['.png', '.jpeg', '.jpg'],
                    complete: function(res) {
                        that.synthesis_qrcode = res[0].web_path
                    }
                })
                uploader.addFile(url, new Date().getTime() + '.png')
                uploader.start()
            })
        },
        popup_switch_show(){
            if(this.now_router_params == 'ChildInformation' && this.option1.length == 0) {
                Toast("暂无可添加子账号的店铺")
                return false;
            }
            if(this.checkbox_list == '1'){
                Toast('请选择接收人角色')
                return false;
            }
            if(!this.receive_name){
                Toast('请填写接收人姓名')
                return false;
            }
            if(this.now_router_params == 'ChildInformation' && !this.stroeValue) {
                Toast('请选择店铺')
                return false;
            }
            let objData = { receive_name:this.receive_name, role_name:this.tag_list[this.checkbox_list]}
            let pathStr = 'AddRecipientInfo/getReceiverQrcode' //换成不是子账号进来的那个请求接口
            if(this.now_router_params == 'ChildInformation') {
                pathStr = 'AddRecipientInfo/addShuntAccount'
                objData = {...objData, ...{visitor_id:this.stroeValue}}
            }
            this.$store.dispatch( // 获取接收人二维码
                pathStr,objData
            ).then((res)=>{
                if(res.code == 5005) {
                    Toast("店铺添加账号已满")
                    return false
                }else
                if( res.code==1000 ){
                    this.qrcode = res.data.qrcode
                    this.popup_show = true
                    setTimeout(()=>{
                        this.toImage()
                        this.timer_worker(res.data.qrcode_id)
                    },0)
                }else{
                    Toast( res.message )
                }
            })
        },
        timer_worker( qrcode_id ){ // 添加二维码状态监听
            this.timer[qrcode_id] = setInterval(()=>{
                this.$store.dispatch( // 轮询扫码状态
                    'AddRecipientInfo/GetQrCodeStatus',
                    {qrcode_id: qrcode_id}
                ).then((status_res)=>{
                    if(status_res.data.is_used){
                        this.clear_timer_worker()
                        this.$store.dispatch('AddRecipient/GetReceivers',{}) // 重新获取接收人列表
                        if(this.now_router_params == 'ChildInformation') {
                            this.$router.push('ChildInformation')
                        }else {
                            this.$router.push('AddRecipient')
                        }
                    }
                })
            },1000)
        },
        clear_timer_worker(){ //清理定时器
            this.timer.map( (m)=>{
                clearInterval(m)
            })
            this.timer = []
        },
        popup_switch_close(){
            this.popup_show = false
        },
        chooseStroe() {
            for(let i in this.option1) {
                if(this.option1[i].value == this.stroeValue) {
                    this.chooseTitle = this.option1[i].text
                }
            }
        },
        dropDownOpen() {
            this.dropDownUp = !this.dropDownUp
        }
    },
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>
<style lang="scss">
// 重写下拉菜单样式
.van-dropdown-menu__title {
    color: #666;
    text-align: left;
    font-size: 3.2vw;
    line-height: 12.5vw;
    padding-left: 3.2vw;
}
.van-dropdown-menu__bar {
    box-shadow: none;
    height: 12.5vw;
}
.van-dropdown-item__option {
    font-size: 3.2vw;
}
.van-cell {
    line-height: 7vw;
    color: #000;
}
.van-dropdown-item__option--active {
    color: #ee0a24;
}
.van-dropdown-menu__title::after {
    display: none !important;
}
.van-dropdown-menu {
    flex-grow: 1;
}
.van-dropdown-menu__item {
    -webkit-justify-content: left;
    justify-content: left;
}
// 下拉列表的样式
.van-cell__title, .van-cell__value {
    -webkit-box-flex: 0;
    -webkit-flex: 0;
    flex: 1;
}
.van-cell__title {
    flex: 8;   
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.van-ellipsis {
    width: 80vw;
}
.van-dropdown-menu__title {
    line-height: 5.2vw;
}
.van-dropdown-menu__bar {
    min-height: 12.5vw;
    height: auto;
}
</style>